
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Button, Form, Input,  Popconfirm, Table,Typography} from 'antd';

import {
  ListingHoldersConcentrationValueThunk,
  ListingHoldersConcentrationKeysThunk,
} from "../../Store/Thunks/ListingHoldersConcentrationThunk";
import { ApiPutListingHoldersConcentrationValue } from '../../Services';
import ReloadIcon from "../../Assets/img/icons/refresh.png";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  
  const inputNode = <Input  className="editable-field" />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={[record.key, dataIndex]}
          style={{
            margin: 0,
          }}
          rules={[
            {message: `Please Input ${title}!`, },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
export const HoldersConcentration = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingKey, setEditingKey] = useState('');
  const [isSaveClicked, setIsSaveClicked] = useState(false);
  const [modifiedRows, setModifiedRows] = useState(new Set());
  const [cellToggleState, setCellToggleState] = useState({}); // Track each cell's state individually
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [bulkEditing, setBulkEditing] = useState(false);


  useEffect(() => {
    dispatch(ListingHoldersConcentrationKeysThunk());
    dispatch(ListingHoldersConcentrationValueThunk());
  }, []);


  const {
    ListingHoldersConcentrationKeyData,
    ListingHoldersConcentrationKeyLoading,
    ListingHoldersConcentrationValueData,
    ListingHoldersConcentrationValueLoading,
  } = useSelector((state) => state.ListingHoldersConcentrationReducer);

  const isEditing = (record) =>
    bulkEditing || record.key === editingKey;

  const edit = (record) => {
  form.setFieldsValue({
    [record.key]: {
      ...record,
      },
    });
    setEditingKey(record.key);
   };

  const cancel = () => {
    setEditingKey('');
  };
 
    const dataSource = () => {
      const arr = [];
      
      ListingHoldersConcentrationValueData?.forEach((item, index) => {
        const obj = {};

        ListingHoldersConcentrationKeyData?.forEach((element) => {
          const key = element.key;
          const manualKey = `${key}Manual`;
          const cellKey = `${item?.listingHoldersConcentration.id}_${key}`;

          const manualDataExists = item?.listingHoldersConcentration[manualKey] && Number(item?.listingHoldersConcentration[manualKey]) !== 0 && item?.listingHoldersConcentration[manualKey] !==null ;
          obj[`${key}_automatic`] = item.listingHoldersConcentration[key]; 
          obj[key] = manualDataExists
        ? item.listingHoldersConcentration[manualKey] 
        : item.listingHoldersConcentration[key];     

          // Store the hasManualData flag for each cell
          obj[`${key}_hasManualData`] = manualDataExists ? true : false;
        });
        obj.id = item.listingHoldersConcentration.id;
        obj.name = item.assetName;

        arr.push({
          ...obj,
          key: index,
        });
      });

      setData(arr);
      return arr;
    };

    useEffect(() => {
      if (
        ListingHoldersConcentrationKeyData?.length &&
        ListingHoldersConcentrationValueData.length
      ) {
        dataSource();
      }
    }, [ListingHoldersConcentrationKeyData, ListingHoldersConcentrationValueData, cellToggleState]);

    const handleToggleCellData = async (rowId, colKey) => {
      const cellKey = `${rowId}_${colKey}`;
      setCellToggleState((prevState) => ({
        ...prevState,
        [cellKey]: !prevState[cellKey],
      }));

      // Prepare data to remove manual entry
      const row = data.find((item) => item.id === rowId);
      if (!row) return;

      const manualKey = `${colKey}Manual`;
      const newItem = { id: row.id, [manualKey]: null }; // Remove manual data

      // Call API to remove manual data
      setLoading(true);
      try {
        await ApiPutListingHoldersConcentrationValue([newItem]);
        setModifiedRows((prev) => {
          const newSet = new Set(prev);
          newSet.delete(cellKey); // Remove the cell from modified rows after save
          return newSet;
        });
        // Fetch updated data from the backend
        dispatch(ListingHoldersConcentrationKeysThunk());
        dispatch(ListingHoldersConcentrationValueThunk());

      } catch (error) {
        console.error("Failed to update manual data:", error);
      } finally {
        setLoading(false);
      }
    };

    const editAssetValue = () => {
      setLoading(true);

      const editData = Array.from(modifiedRows).reduce((acc, cellId) => {  
        if (typeof cellId === "string") {
          const [rowId, colKey] = cellId.split('_');
          const row = data.find((item) => item.id === parseInt(rowId, 10));
          if (!row) return acc;

          // Find or initialize an item in acc for this row ID
          let newItem = acc.find((item) => item.id === row.id);
          if (!newItem) {
            newItem = { id: row.id };
            acc.push(newItem);
          }

          // Set only modified fields in newItem
          const value = row[colKey];
          const manualKey = `${colKey}Manual`;

          if (colKey === 'addressesHoldingMore1Percent') {
            newItem[manualKey] = value ? String(value) : "";
          } else if (colKey === 'addressesHolding01To1Percent') {
            newItem[manualKey] = value ? String(value) : "";
          } else if (colKey === 'addressesHoldingLess01Percent') {
            newItem[manualKey] = value ? String(value) : "";
          } else if (colKey === 'holdersMore01PercentNetflow7Day') {          
            newItem[manualKey] = value ? String(value) : "";
          }
          else {
            // Handle other cases if needed
            newItem[manualKey] = value; 
          }
        }
        return acc;
      }, []);

      ApiPutListingHoldersConcentrationValue(editData)
        .then(() => {
          setLoading(false);
          setModifiedRows(new Set());

          // Fetch updated data from the backend
      dispatch(ListingHoldersConcentrationKeysThunk());
      dispatch(ListingHoldersConcentrationValueThunk());
        })
        .catch(() => {
          setLoading(false);
        });
    };

      const save = async (key) => {
        try {
          const values = await form.validateFields();
        
          const rowValues = values[key];
          if (!rowValues) return;

          const row = data.find(item => item.key === key);
          if (!row) return;

          // Update UI state
          setData(prev =>
            prev.map(r =>
              r.key === key
                ? { ...r, ...rowValues }
                : r
            )
          );

          // Build correct API payload
          const payload = Object.keys(rowValues).map(colKey => ({
            id: row.id,
            [`${colKey}Manual`]: String(rowValues[colKey] ?? "")
          }));

          // Save
          setLoading(true);
          await ApiPutListingHoldersConcentrationValue(payload);

          // Refresh
          dispatch(ListingHoldersConcentrationKeysThunk());
          dispatch(ListingHoldersConcentrationValueThunk());

          setEditingKey('');
          setLoading(false);
        } catch (err) {
          console.log(err);
          setLoading(false);
        }
      };

    useEffect(()=>{
      if(isSaveClicked)
      dispatch(ListingHoldersConcentrationKeysThunk());
      dispatch(ListingHoldersConcentrationValueThunk());
    },[isSaveClicked])

    useEffect(()=>{
      if(modifiedRows && isSaveClicked){
        editAssetValue();
      }
      setIsSaveClicked(false)
    },[modifiedRows,isSaveClicked])
   
  const columns = () => {
    return [
      {
        title: "#",
        dataIndex: "index",
        key: "index",
        width: 60,
        render: (text, record, index) => index + 1,
      },
      {
        title: 'Asset',
        dataIndex: 'name',
        fixed: 'left',
        width: 100,
      },
      ...ListingHoldersConcentrationKeyData.filter((item) => item.key !== "addressesHoldingMore1PercentExceed").map((item) => ({
        title: item.name,
        dataIndex: item.key,
        editable: true,
        width: 80,
        render: (text, record) => {
        const hasManualData = record[`${item.key}_hasManualData`];
        const automaticValue = record[`${item.key}_automatic`];

        const showAutomaticSymbol =
          hasManualData &&
          automaticValue !== null &&
          automaticValue !== undefined && automaticValue !== "0";

          const cellKey = `${record.id}_${item.key}`;
          const isManualDataDisplayed = cellToggleState[cellKey];     
          return (
            <div style={{ position: 'relative' }}>
              <span style={{ color: (hasManualData && !isManualDataDisplayed) ? "#1890ff" : "#000" }}>
                {/^-|\d+(\.\d+)?$/.test(text)
                  ? text && text !== "0"
                   ? text.includes(",")? text
                   : Number(text).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : text.toString()
                  : text                 
                 }
              </span>
                 {showAutomaticSymbol && (
              <span className="has_automatic" title={ /^-|\d+(\.\d+)?$/.test(automaticValue)
                  ? automaticValue && automaticValue !== "0"
                   ? automaticValue.includes(",")? automaticValue
                   : Number(automaticValue).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : automaticValue.toString()
                  : automaticValue                 
                 }>A</span>
            ) }
              {(hasManualData) && (
                <img
                  src={ReloadIcon}
                  alt="Reload"
                  style={{
                    width: "20px",
                    position: "absolute",
                    top: "50%",
                    right: "10px",
                    transform: "translateY(-50%)"
                  }}
                  onClick={() => handleToggleCellData(record.id, item.key)} // Toggle specific cell
                />
              )}
            </div>
          );
        }
      })),
      {
        title: 'Operation',
        dataIndex: 'operation',
        fixed: 'right',
        width: 100,
        render: (_, record) => {
          const editable = isEditing(record);
          return editable && !bulkEditing ? (
            <span>
              <Typography.Link onClick={() => save(record.key)} style={{ marginRight: 8 }}>
                Save
              </Typography.Link>
               <Popconfirm
                                title="Sure to cancel?"
                                okText="Cancel"
                                cancelText="No"
                                okButtonProps={{ style: { float: 'right' } }}
                                cancelButtonProps={{ style: { float: 'left' } }}
                                onConfirm={cancel}
                                  overlayStyle={{ paddingBottom:"20px" }}
                              >
                                <a>Cancel</a>
                       </Popconfirm>
            </span>
          ) : (
            !bulkEditing ?
            <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
              Edit
            </Typography.Link>
            : null
          );
        },
      },
    ];
  };
  const mergedColumns = columns().map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: 'number',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const rowSelection = {
  selectedRowKeys,
  onChange: setSelectedRowKeys,
  getCheckboxProps: (record) => ({
    disabled: editingKey !== '' && !selectedRowKeys.includes(record.key),
  }),
};
const bulkEdit = () => {
  const values = {};

  data.forEach(row => {
    if (selectedRowKeys.includes(row.key)) {
      values[row.key] = row;
    }
  });

  form.setFieldsValue(values);
  setBulkEditing(true);
};

const bulkSave = async () => {
  try {
    const values = await form.validateFields();
    const newData = [...data];
    const editData = [];

    Object.keys(values).forEach(rowKey => {
      const rowIndex = newData.findIndex(
        item => item.key === Number(rowKey)
      );
      if (rowIndex === -1) return;

      const row = newData[rowIndex];
      const updatedRow = values[rowKey];

      Object.keys(updatedRow).forEach(colKey => {
        if (updatedRow[colKey] !== row[colKey]) {
          row[colKey] = updatedRow[colKey];

          editData.push({
            id: row.id,
            [`${colKey}Manual`]: String(updatedRow[colKey] ?? "")
          });
        }
      });

      newData[rowIndex] = row;
    });

    setData(newData);

    if (editData.length) {
      setLoading(true);
      await ApiPutListingHoldersConcentrationValue(editData);
      dispatch(ListingHoldersConcentrationKeysThunk());
      dispatch(ListingHoldersConcentrationValueThunk());
    }

    setBulkEditing(false);
    setSelectedRowKeys([]);
    form.resetFields();
    setLoading(false);
  } catch (e) {
    console.log(e);
    setLoading(false);
  }
};

  return (
    <div>      
    <Form form={form} component={false}>
      <Table
       rowSelection={rowSelection}
      loading={ListingHoldersConcentrationKeyLoading || ListingHoldersConcentrationValueLoading  || loading}
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        pagination={false}
        bordered
        dataSource={data}
        className="custom-scroll"
        columns={mergedColumns}
        rowClassName="editable-row"      
        scroll={{ y: 500 }}
      />
    </Form>
    <div style={{ marginTop: 20 }}>
  <Button
    disabled={!selectedRowKeys.length || editingKey !== ''}
    onClick={bulkEdit}
  >
    Bulk Edit
  </Button>

  {bulkEditing && (
    <>
      <Button
        type="primary"
        style={{ marginLeft: 8 }}
        onClick={bulkSave}
      >
        Bulk Save
      </Button>

      <Button
        style={{ marginLeft: 8 }}
        onClick={() => {
          setBulkEditing(false);
          setSelectedRowKeys([]);
          form.resetFields();
        }}
      >
        Cancel
      </Button>
    </>
  )}</div>
    </div>
  );
}  